/**
 * @param {Object} img
 * @param {function} callback
 */
function loadImageSrc(img, callback) {

    img.onload = function () {
        img.classList.remove("lazy", "lazy-img", 'lazy-image', 'carousel-lazy-img');
        let spinner = img.closest('div').querySelector('.spinner-grow');
        if (spinner) spinner.remove();
        img.classList.add("loaded");

        let shareBtn = img.closest('.il-image-container')?.querySelector('.il-share-image-btn');
        if (shareBtn) shareBtn.classList.add('il-share-ready');

        if (callback)
            callback(img);
    };

    if (img.parentNode.nodeName === "PICTURE") {
        let sources = img.parentNode.querySelectorAll("source");
        let imgWidth = img.width = img.clientWidth;
        img.height = img.clientHeight;

        sources.forEach(source => {
            source.sizes = imgWidth + 'px';
            source.srcset = source.dataset.srcset;
        });
    }

    img.src = img.dataset.src;

}
export default loadImageSrc;
